/*
import React from 'react'
import {Link} from 'react-router-dom'
import { formatDistanceToNow } from 'date-fns'
*/
import { pt, de } from 'date-fns/locale'
import model from 'components/model'

export const users = {}

hp.settings.current_locale = {locale: hp.settings.locale == 'de-de' ? de : pt};
hp.settings.chat = hp.store.chatconfig;
delete hp.store.chatconfig;

export class User {
	constructor(uid) {
		this.uid = uid;
		// armazena informação pessoal como nome, logo, etc
		this.profile = {};
		// indica a ultima vez que devolveu do servidor, o feed deste user
		this.last_updated = null;
		this.feed = model();
		// preserva informação sobre pageNum, count, etc. do feed
		this.meta = {};
	}

	setProfile(value) {
		this.profile = value;
	}

	get isLoggedIn() {
		return this.uid > 0
	}
	get logo() {
		//return '/media/images/users/' + this.uid + '.png'
		return this.profile.logo;
	}

	createModel(type, name = undefined) {
		const model = {
			type: type,
			share: this.feed.length > 0 ? this.feed.data[0].share : 1,
			comment: '',
			tags: '',
			_show_help: hp.store.config.help_create_post == 1
		}
		if (name !== undefined ) {
			model.name = name;
		}
		return model;
	}

	getFeed() {
		return this.feed
	}

	getFeedReverse() {
		return [...this.feed.data].reverse();
	}

	saveContent(content) {
		content.updated_at = new Date();
		if (this.feed.get(content.id)) {
			const feed = this.feed.get(content.id);
			Object.assign(feed, content);
		}
		else {
			//this.feed.push(content);
			this.feed.unshift(content);
		}
	}

	static merge(profiles) {
		for (let uid in profiles) {
			const usr = users.hasOwnProperty(uid) ? users[uid] : users[uid] = new User(uid);
			usr.setProfile(profiles[uid]);
		}
	}

	setFeed(response) {
		const profiles = response.profiles;
		const feed = response.feed;

		//Object.keys(feed).forEach(i => feed[i].updated_at = new Date(feed[i].updated_at));
		feed.forEach(f => f.updated_at = new Date(f.updated_at));
		if (response.meta.page == 1) {
			this.feed = model(feed);
		}
		else {
			this.feed.push(feed);
		}
		//this.feed.merge(feed);
		User.merge(profiles);
/*
		for (let uid in profiles) {
			const usr = users.hasOwnProperty(uid) ? users[uid] : users[uid] = new User(uid);
			usr.setProfile(profiles[uid]);
		}
*/
		this.meta = response.meta;
		this.last_updated = response.last_updated;
	}

	update(next = 0) {
		// determinar se a pesquisa foi alterada
		const clear = this.meta.feed_filter != hp.store.feed_filter;
		return new Promise((resolve, success) => {
			http.post('/home/getFeed/' + this.uid + '.json', {
				filter: hp.store.feed_filter || '',
				page: next == 0 ? 1 : this.meta.page + next,
				item_per_page: this.meta.item_per_page
			}, response => {
				if (clear) {
					response.meta.page = 1;
				}
				if (response.feed) {
					this.setFeed(response);
				}
				this.meta.feed_filter = hp.store.feed_filter;
				resolve(this)
			})
		})
	}

	static submitImage(file, type, callback, uid = 0, props = {}) {
		const data = new FormData();

		if (uid) {
			data.append('uid', uid);
		}
		data.append('file', file);
		data.append('type', type);
		if (Object.keys(props).length > 0) {
			data.append('props', JSON.stringify(props));
		}
		http.post('/home/submitImage.json', {
			type: 'POST',
			data: data
		}, (response, success) => {
			const usr = user.get(uid || hp.store.uid);
			if (success && response.file && usr) {
				usr.profile[type] = response.file;
			}
			if (callback instanceof Function) {
				callback();
			}
		})
	}

	deleteFeed(model) {
		this.feed.delete(model);
	}
}
User.renders = {1: 'Photo', 2: 'Video', 3: 'News', 4: 'File'}

const user = (function() {
	const main = new User(hp.store.uid);
	let usr = main;

	users[hp.store.uid] = main;
	if (hp.store.feed.uid !== hp.store.uid) {
		usr = new User(hp.store.feed.uid);
		users[hp.store.feed.uid] = usr;
	}
	usr.setFeed(hp.store.feed);

	return {
		main: main,
		get: uid => users.hasOwnProperty(uid) ? users[uid] : null,
		isLoggedIn: () => main.isLoggedIn,
		logo: (uid, name = 'logo') => users.hasOwnProperty(uid, name) ? users[uid].profile[name] : null, /*(
			'/media/images/users/' + (uid || main.uid) + '.png'
		),*/
		canEditProfile: (uid = 0) => uid === main.uid || (main.uid > 0 && !uid),
		hasMoreFeeds: (uid = 0) => {
			uid = uid === undefined ? main.uid : uid;
			if (!users.hasOwnProperty(uid)) {
				return false;
			}
			const usr = users[uid];
			return usr.feed.length < usr.meta.item_count;
		},
		loadFeed: (uid = 0, next = 0) => {
			uid = uid === undefined ? main.uid : uid;
			usr = !users.hasOwnProperty(uid) ? (users[uid] = new User(uid)) : users[uid];
			return usr.update(next);
		},
		toggleFollow: uid =>
			new Promise((resolve, success) => {
				const following = hp.store.followers.get(uid);
				http.post('/home/follow.json', {uid: uid, follow: following == null}, response => {
					if (following != null) {
						hp.store.followers.delete(following);
					}
					else {
						hp.store.followers.unshift(response.user);
					}
					resolve(this)
				})
			})
	}
})()

export default user
